// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"194":"776da804","453":"ed36841d","895":"fb079352"}[chunkId] + ".chunk.js";
};